import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import StyledSelect from "~styled/select/StyledSelect";

interface PhoneTipoSelectorProps {
  value: boolean;
  onChange?: (event: any) => void;
  disabled?: boolean;
  /** Sin la etiqueta TIPO ni subrayado, para ir adentro de otro campo. */
  inline?: boolean;
}

const PhoneTipoSelector: React.FC<PhoneTipoSelectorProps> = ({
  value,
  onChange,
  disabled,
  inline,
}) => {
  // `key` es una prop reservada de React y nunca llega al componente, así que el
  // identificador siempre fue el mismo. Se conserva tal cual para no cambiar el DOM.
  const labelId = "moneda-label-0";

  if (inline)
    return (
      <StyledSelect
        variant="standard"
        disableUnderline
        disabled={disabled}
        value={value}
        inputProps={{ "aria-label": "TIPO" }}
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: "#6240a5",
          "& .MuiSelect-select": {
            fontSize: 14,
            padding: "0 22px 0 0",
            lineHeight: "22px",
            minHeight: 0,
          },
          "& .MuiSelect-select:focus": { backgroundColor: "transparent" },
          "& .MuiSelect-icon": { right: 0 },
          // Fijo en un tipo no hace falta la flecha.
          "&.Mui-disabled .MuiSelect-select": {
            paddingRight: 0,
            color: "#8B8B8B",
            WebkitTextFillColor: "#8B8B8B",
          },
          "&.Mui-disabled .MuiSelect-icon": { display: "none" },
        }}
        onChange={onChange}
      >
        <MenuItem value={true as any}>MÓVIL</MenuItem>
        <MenuItem value={false as any}>FIJO</MenuItem>
      </StyledSelect>
    );

  return (
    <FormControl disabled={disabled}>
      <InputLabel
        sx={{
          transform: "translate(0, 12px) scale(1)",
          transformOrigin: "top left",
          "&.MuiInputLabel-shrink": {
            transform: "translate(0, -1px) scale(0.75)",
          },
        }}
        id={labelId}
      >
        TIPO
      </InputLabel>
      <StyledSelect
        variant="standard"
        labelId={labelId}
        value={value}
        style={{ minWidth: 81, alignContent: "start" }}
        onChange={onChange}
      >
        <MenuItem value={true as any}>MÓVIL</MenuItem>
        <MenuItem value={false as any}>FIJO</MenuItem>
      </StyledSelect>
    </FormControl>
  );
};

export default PhoneTipoSelector;
